import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import SimpleCell from './SimpleCell';

const MessageCell = ({
  children,
  className,
  collapsing,
  colSpan,
  disabled,
  messageArgs,
  messageId,
  textAlign,
}) => {
  const intl = useIntl();
  return (
    <SimpleCell
      className={clsx('aridhia-message-cell', className)}
      content={intl.formatMessage({ id: messageId }, messageArgs)}
      disabled={disabled}
      colSpan={colSpan}
      collapsing={collapsing}
      textAlign={textAlign}
    >
      {children}
    </SimpleCell>
  );
};

export default MessageCell;
